import {
  CamperIcon,
  HatchbackIcon,
  TractorIcon,
  TruckIcon,
  VanIcon,
} from '@kvdbil/components';
import { TFunction } from 'i18next/typescript/t';

export const vehicleTypeChipSwitch = (t: TFunction, vehicleType: string) => {
  switch (vehicleType) {
    case 'LIGHT_TRANSPORT':
      return {
        icon: <VanIcon />,
        label: t('Light transport'),
      };
    case 'HEAVY_TRANSPORT':
      return {
        icon: <TruckIcon />,
        label: t('Heavy transport'),
      };
    case 'RECREATIONAL_VEHICLE':
      return {
        icon: <CamperIcon />,
        label: t('Recreational vehicle'),
      };
    case 'MACHINES':
      return {
        icon: <TractorIcon />,
        label: t('Machines'),
      };
    case 'CAR':
    default:
      return {
        icon: <HatchbackIcon />,
        label: t('Car'),
      };
  }
};
